export default {
  'inputPlaceholder': '请输入',
  'selectPlaceholder': '请选择',
  'requiredMsg': '此项为必填项！',
  'minLengthMsg': '最少输入',
  'maxLengthMsg': '最多输入',
  'minMsg': '不能小于',
  'maxMsg': '不能大于',
  'emailMsg': '邮箱格式有误！',
  'patternMsg': '输入格式不正确！',
  'count': '个字！',
  'exclamation': '！',
  'reset': '恢复默认',
  'maximumLengthThirty-two': '最大长度为32',
  'nameExistError' : '名称已存在',
};
